export default "__VITE_ASSET__qmJTuKDf__"